import { call, put, takeLatest, all, cancelled } from "redux-saga/effects"
import axios from "axios"
import { generateTree } from "../../../utils/utils"
import {
  GET_DRILLDOWN_DIVISIONS_WATCHER,
  GET_DIMENSIONS_WATCHER,
  GET_GRAPHIC_BAR_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
} from "./constants"

import {
  getDivisionsSuccess,
  getDimensionsSuccess,
  getDivisionsFailed,
  getGraphicBarsSuccess,
  getMeasureColorRangeSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../../utils/storage"

function getDimensionsApi(params) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.measure}/dimensions`,
    params: { id_segment: params.id_segment },
  })
}

function getDivisionsApi(params) {
  let url = `reports/measure/${params.measure}/leaders?f`
  if (params.dimension) {
    url = `reports/measure/${params.measure}/dimensions/${params.dimension}/leaders?f`
  }
  if (params.search != "") {
    url = `${url}&filter[searchByNameLeader]=${params.search}`
  }
  if (params.level) {
    url = `${url}&filter[idDivision]=${params.level}`
  }

  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: {
      id_segment: params.id_segment,
      recipients: params.recipients || false,
    },
  })
}

function getReportMeasureInfoApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.measure}/info`,
    params: { id_segment: params.id_segment },
  })
}

export function* getDivisionsSaga(params) {
  try {
    const [divionsApi, measureInfo] = yield all([
      call(getDivisionsApi, params.payload),
      call(getReportMeasureInfoApi, params.payload),
    ])

    const result = {
      data: divionsApi.data.data,
      data_drilldown:
        divionsApi.data.data.length > 0
          ? generateTree("id", "id_parent", divionsApi.data.data)
          : [],
      metric: divionsApi.data.metric_total,
      show_history: divionsApi.data.show_history,
      switchMoreDimensions: divionsApi.data.switch,
      measureInfo: measureInfo.data.data,
    }
    result.levels = result.data
      .map((e) => e.division_level)
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => result.data[e])
      .map((e) => result.data[e].division_level)
    yield put(getDivisionsSuccess(result))
  } catch (e) {
    yield put(getDivisionsFailed())
  }
}

export function* getDimensionsSaga(params) {
  try {
    const dimensionsApi = yield call(getDimensionsApi, params.payload)
    const result = {}
    result.dimensions = dimensionsApi.data.data
    yield put(getDimensionsSuccess(result))
  } catch (e) {}
}

export function* getGraphicBarsSaga(action) {
  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "POST",
      endpoint: `reports/measure/${action.payload.idMeasure}/leader/historical/comparative/chart`,
      data: { ...action.payload.data, id_segment: action.payload.id_segment,first_level: action.payload.first_level,id_position: action.payload.id_position  },
      params: { id_segment: action.payload.id_segment},
    })

    yield put(getGraphicBarsSuccess(data))
  } catch (error) {}
}

// MEASURE COLOR RANGE
function getMeasureColorRangeApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.payload.measure}/color-range`,
    params: { id_segment: params.id_segment },
  })
}

export function* getMeasureColorRangeSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const response = yield call(getMeasureColorRangeApi, params)

    yield put(getMeasureColorRangeSuccess(response.data.data))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Individual exports for testing
export default function* teamAnalysisSaga() {
  yield takeLatest(GET_DRILLDOWN_DIVISIONS_WATCHER, getDivisionsSaga)
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
  yield takeLatest(GET_GRAPHIC_BAR_WATCHER, getGraphicBarsSaga)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  // See example in containers/HomePage/saga.js
}
